import { useTranslation } from 'react-i18next'
import BottomSheet from '../mobile/BottomSheet'
import MaterialIcon from '../ui/MaterialIcon'
import { KILO } from '../../constants/KILO_THEME'
import type { ConflictAlert, SuggestedSlot } from '../../lib/conflicts'
import { formatConflictTimeRange } from '../../lib/conflicts'
import ConflictAlertCard from './ConflictAlertCard'

type ConflictListSheetProps = {
  open: boolean
  onClose: () => void
  conflicts: ConflictAlert[]
  onReschedule: (alert: ConflictAlert, slot: SuggestedSlot) => Promise<void>
  onDismiss: (alertId: string) => Promise<void>
}

const ConflictListSheet = ({
  open,
  onClose,
  conflicts,
  onReschedule,
  onDismiss,
}: ConflictListSheetProps) => {
  const { t } = useTranslation()

  return (
    <BottomSheet variant="dark" open={open} onClose={onClose} title={t('profile.conflictsListTitle')}>
      <div className="flex flex-col gap-4">
        {conflicts.length === 0 ? (
          <p className={`text-sm ${KILO.text.muted}`}>{t('profile.conflictsListEmpty')}</p>
        ) : (
          conflicts.map((alert) => (
            <div key={alert.id} className="space-y-2">
              {alert.workout && alert.calendarEvent ? (
                <p className="text-xs text-neutral-500">
                  {formatConflictTimeRange(alert.workout.startsAt, alert.workout.endsAt)}
                  {' · '}
                  {alert.calendarEvent.title}
                </p>
              ) : null}
              <ConflictAlertCard
                alert={alert}
                onReschedule={(slot) => onReschedule(alert, slot)}
                onDismiss={() => onDismiss(alert.id)}
              />
            </div>
          ))
        )}
        <button
          type="button"
          className="group flex h-11 items-center justify-center gap-2 rounded-xl border border-kilo-border bg-neutral-900 text-sm font-semibold text-white"
          onClick={onClose}
        >
          <MaterialIcon name="close" hoverable size="sm" />
          {t('common.close')}
        </button>
      </div>
    </BottomSheet>
  )
}

export default ConflictListSheet
